import { BrokenRollsPage } from "./BrokenRollsPage";

const BrokenRolls = () => {
	return <BrokenRollsPage />;
};
export default BrokenRolls;
